import axios from "axios";
import { getApiBase } from "./apiBase";

const api = () => axios.create({ baseURL: getApiBase() });
const adminConfig = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` } });

export const getMathLibrary = async () => (await api().get("/api/math/library")).data;
export const getMathCourses = async (admin = false) => (await api().get(`/api/math/courses${admin ? "?admin=true" : ""}`)).data;
export const saveMathLibrary = async (data) => (await api().put("/api/math/library", data, adminConfig())).data;
export const createMathCourse = async (data) => (await api().post("/api/math/courses", data, adminConfig())).data;
export const updateMathCourse = async (id, data) => (await api().put(`/api/math/courses/${id}`, data, adminConfig())).data;
export const deleteMathCourse = async (id) => api().delete(`/api/math/courses/${id}`, adminConfig());
export const uploadMathAsset = async (id, type, file) => {
  const form = new FormData();
  form.append("file", file);
  return (await api().post(`/api/math/courses/${id}/${type}`, form, adminConfig())).data;
};
export const uploadMathPages = async (id, files) => {
  const form = new FormData();
  Array.from(files).forEach((file) => form.append("files", file));
  return (await api().post(`/api/math/courses/${id}/pages`, form, adminConfig())).data;
};
